import React, { useEffect, useState } from 'react';
import { showError, sortArray } from 'utils';
import _ from 'lodash';
import { fetchAllSalesChannels } from 'services/api/salesChannel';

const SalesChannelDropwdown = props => {
  const [salesChannels, setSalesChannels] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    value,
    onChange,
  } = props;

  const fetchAllSalesChannelFn = async () => {
    try {
      setLoading(true);
      const response = await fetchAllSalesChannels();
      setSalesChannels(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllSalesChannelFn();
  }, []);
  
  const handleSelect = (id: string) => {
    onChange(id);
  };

  const getOptions = () => sortArray(salesChannels, 'name').map((row, i) => (
    <option key={i} value={row.objectId}>{row.name}</option>
  ));

  return (
    <>
      <select
        disabled={!salesChannels.length || loading}
        className={'form-control'}
        onChange={e => handleSelect(e.target.value)}
        value={value}
      >
        <option value=''>Choose Sales Channel</option>
        {salesChannels.length && getOptions()}
      </select>
    </>
  );
};

export default SalesChannelDropwdown;